import { useCallback, useContext, useState } from 'react';
import { addMonths, endOfMonth, startOfMonth, subMonths } from 'date-fns';
import { useTranslation } from 'react-i18next';
import LeftArrow from '../../../components/icons/LeftArrow.svg?react';
import RightArrow from '../../../components/icons/RightArrow.svg?react';
import { calendarConstants } from '../Calendar.constant';
import StandaloneCalendarContext from '../CalendarContext';
import {
  ButtonLeftRight,
  Divider,
  MonthsNavigationWrapper,
} from './Navigation.styles';

const MonthsNavigation = () => {
  const { t } = useTranslation();
  const [leftHover, setLeftHover] = useState(false);
  const [rightHover, setRightHover] = useState(false);
  const { calendarFilter, setCalendarFilter } = useContext(
    StandaloneCalendarContext,
  );

  const onPrevious = useCallback(() => {
    if (!calendarFilter) return false;

    const previousStartRange = subMonths(
      calendarFilter.start,
      calendarConstants.numberOfMonthsToDisplayOnCalendar,
    );
    calendarFilter.start = startOfMonth(previousStartRange);
    calendarFilter.end = endOfMonth(
      addMonths(
        previousStartRange,
        calendarConstants.numberOfMonthsToDisplayOnCalendar - 1,
      ),
    );

    setCalendarFilter({ ...calendarFilter });
    return false;
  }, [calendarFilter?.start]);

  const onNext = useCallback(() => {
    if (!calendarFilter) return false;

    const nextStartRange = addMonths(
      calendarFilter.start,
      calendarConstants.numberOfMonthsToDisplayOnCalendar,
    );
    calendarFilter.start = startOfMonth(nextStartRange);
    calendarFilter.end = endOfMonth(
      addMonths(
        nextStartRange,
        calendarConstants.numberOfMonthsToDisplayOnCalendar - 1,
      ),
    );

    setCalendarFilter({ ...calendarFilter });
    return false;
  }, [calendarFilter?.end]);

  return (
    <MonthsNavigationWrapper data-testid="months-navigation-wrapper">
      <ButtonLeftRight
        $hover={leftHover}
        type="button"
        onPointerOver={() => setLeftHover(true)}
        onPointerOut={() => setLeftHover(false)}
        onClick={onPrevious}
        data-testid="calendar-left-arrow"
      >
        <LeftArrow />
      </ButtonLeftRight>

      <div>
        <span data-testid="calendar-filter-date">
          {calendarFilter?.start
            ? t('common.monthFullYear', { date: calendarFilter.start })
            : ''}
        </span>
        <Divider>-</Divider>
        <span>
          {calendarFilter?.end
            ? t('common.monthFullYear', { date: calendarFilter.end })
            : ''}
        </span>
      </div>

      <ButtonLeftRight
        $hover={rightHover}
        type="button"
        onPointerOver={() => setRightHover(true)}
        onPointerOut={() => setRightHover(false)}
        onClick={onNext}
      >
        <RightArrow />
      </ButtonLeftRight>
    </MonthsNavigationWrapper>
  );
};

export default MonthsNavigation;
